import { render, staticRenderFns } from "./orderImp.vue?vue&type=template&id=5a626056&scoped=true&"
import script from "./orderImp.vue?vue&type=script&lang=js&"
export * from "./orderImp.vue?vue&type=script&lang=js&"
import style0 from "./orderImp.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./orderImp.vue?vue&type=style&index=1&id=5a626056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a626056",
  null
  
)

export default component.exports